module.exports = __webpack_public_path__ + "static/media/Unloaded.a9680ab1.png";